import {observer} from 'mobx-react';
import s from '../../../s';
import React, {useCallback} from 'react';
import {InsigniaPositionEnum} from '../../../rendering/render.def';

export const InsigniaPosition = observer(() => {
    const changePosition = useCallback((value: string) => {
        s.pcs.InsigniaPosition = +value;

        if (s.pcs.InsigniaPosition === InsigniaPositionEnum.Top) {
            s.pcs.ProductTypeID = 91;
            s.ps.ProductTypeID = 91;
            s.pcs.DYF_FrameStyleID = 12;
        } else {
            s.ps.ProductTypeID = s.prod.ProductTypeID;
            s.pcs.ProductTypeID = s.prod.ProductTypeID;
            s.pcs.DYF_FrameStyleID = s.prod.DYF_FrameStyleID;
        }

        s.ui.doRender = true;
        s.ui.update_pricing = true;
        s.pulse();
    }, []);

    return (
        <div>
            <label
                htmlFor="ins-position"
                style={{paddingRight: 10}}
            >
                <strong>Position:</strong>
            </label>
            <select
                aria-label="Select insignia position"
                name="ins-position"
                id="ins-position"
                className="form-select d-inline-block"
                style={{width: 110}}
                onChange={e => changePosition(e.target.value)}
                value={s.pcs.InsigniaPosition}
            >
                <option value={InsigniaPositionEnum.Bottom}>Bottom</option>
                <option value={InsigniaPositionEnum.Top}>Top</option>
            </select>
        </div>
    );
});
